import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bannerModules = _resolveComponent("bannerModules")!
  const _component_filterDisplay = _resolveComponent("filterDisplay")!
  const _component_cardsDisplay = _resolveComponent("cardsDisplay")!
  const _component_containerComponent = _resolveComponent("containerComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_bannerModules),
    _createVNode(_component_containerComponent, null, {
      default: _withCtx(() => [
        _createVNode(_component_filterDisplay),
        _createVNode(_component_cardsDisplay)
      ]),
      _: 1
    })
  ], 64))
}